import { render, staticRenderFns } from "./SelectModel.vue?vue&type=template&id=71f4f6b2&scoped=true"
import script from "./SelectModel.vue?vue&type=script&lang=js"
export * from "./SelectModel.vue?vue&type=script&lang=js"
import style0 from "./SelectModel.vue?vue&type=style&index=0&id=71f4f6b2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4f6b2",
  null
  
)

export default component.exports